import React from 'react';
import BaseComponent from '../../../../baseClasses/BaseComponent'; // Change to point to the right level in the file structure
import RadioButtonPanel from '../../../../components/Buttons/RadioButtonPanel';
import './YesNoRadioButtonPanel.scss';

export default class YesNoReadioButtonPanel extends BaseComponent {
  render() {
    const { data } = this.props;
    let size = this.props.size ? this.props.size : 'regular';
    let buttonWidth = this.props.buttonWidth ? this.props.buttonWidth : 55;
    if (this.props.textOnly) {
      buttonWidth = 30;
    }

    const yesNoOptions = [{
      type: 'yes',
      value: this.props.yes,
      checked: this.props.yes,
      buttonLabel: this.props.textOnly ? 'Yes' : 'Yes',
      data: data,
    },
      {
        type: 'no',
        value: !this.props.yes,
        checked: !this.props.yes,
        buttonLabel: 'No',
        data: data,
      }];
    
    return (
      /* panelLabel, panelLabelPosition, buttonLabelPosition, size, buttonHeight*/
      <RadioButtonPanel panelLabel={this.props.panelLabel} panelLabelPosition={this.props.panelLabelPosition}
        buttonLabelPosition="right" size={size} options={yesNoOptions} horizontal={true} buttonWidth={buttonWidth}
        handleClick={this.props.handleSelection} item={this.props.item} textOnly={this.props.textOnly}/>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Buttons/RadioButtonPanel/YesNoRadioButtonPanel/index.js